import { render, staticRenderFns } from "./IconFileText.vue?vue&type=template&id=46557b5d"
import script from "./IconFileText.vue?vue&type=script&lang=js"
export * from "./IconFileText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports